module.exports = __webpack_public_path__ + "static/media/clover-go.b0666055.png";